var styles = {"link":"styles_link__FYIh-","disabled":"styles_disabled__o6IRf","icons":"styles_icons__P-4vR","actions":"styles_actions__CVRH2","linkElement":"styles_link-element__26bYy","noSpacing":"styles_no-spacing__sFAoK","compactSpacing":"styles_compact-spacing__Pdd8k","comfortableSpacing":"styles_comfortable-spacing__DzVYq","looseSpacing":"styles_loose-spacing__j7qh-"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
